/**
 * Glend Meta Pixel Custom Events
 * Fires ViewContent, AddToCart, InitiateCheckout with rich product data
 * Base pixel (init + PageView) is in theme.liquid
 */
(function () {
  'use strict';

  function fbqSafe() {
    if (typeof fbq !== 'undefined') fbq.apply(null, arguments);
  }

  function centsToEur(cents) {
    return Number((cents / 100).toFixed(2));
  }

  // Generate unique event ID for deduplication with Shopify's native pixel
  function eventId(prefix) {
    return prefix + '_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  // --- ViewContent: fires on product pages ---
  function trackViewContent() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (!meta || meta.page.pageType !== 'product') return;

    var product = meta.product || {};
    var url = new URL(window.location.href);
    var variantFromUrl = url.searchParams.get('variant');
    var variantId = variantFromUrl || (product.variants && product.variants[0] ? product.variants[0].id : product.id);
    var price = product.variants && product.variants[0] ? centsToEur(product.variants[0].price) : 0;

    fbqSafe('track', 'ViewContent', {
      content_ids: [String(variantId)],
      content_name: product.title || document.title,
      content_type: 'product',
      value: price,
      currency: 'EUR'
    }, { eventID: eventId('vc') });
  }

  // --- AddToCart: subscribe to cart-update ---
  function trackAddToCart() {
    if (typeof subscribe !== 'function') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || !event.cartData) return;
      var source = event.source || '';

      var addSources = ['product-form', 'sticky-add-to-cart', 'quick-add', 'cart-upsell'];
      var isAdd = addSources.some(function (s) { return source.indexOf(s) !== -1; });
      if (!isAdd) return;

      var item = event.cartData;
      if (!item.product_title) return;

      // Fetch full cart for item count
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var atcId = eventId('atc');
          fbqSafe('track', 'AddToCart', {
            content_ids: [String(item.variant_id)],
            content_name: item.product_title,
            content_type: 'product',
            value: centsToEur(item.price * item.quantity),
            currency: 'EUR',
            num_items: cart.item_count
          }, { eventID: atcId });
        })
        .catch(function () {
          fbqSafe('track', 'AddToCart', {
            content_ids: [String(item.variant_id)],
            content_name: item.product_title,
            content_type: 'product',
            value: centsToEur(item.price * item.quantity),
            currency: 'EUR'
          }, { eventID: eventId('atc') });
        });
    });
  }

  // --- Search: fires on search results page with the query ---
  function trackSearch() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (!meta || !meta.page || meta.page.pageType !== 'search') return;
    var q = new URL(window.location.href).searchParams.get('q') || '';
    if (!q) return;
    fbqSafe('track', 'Search', {
      search_string: q
    }, { eventID: eventId('sr') });
  }

  // --- InitiateCheckout: click on checkout button ---
  function trackInitiateCheckout() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[name="checkout"], #CartDrawer-Checkout, #checkout');
      if (!btn) return;

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ids = cart.items.map(function (item) { return String(item.variant_id); });
          fbqSafe('track', 'InitiateCheckout', {
            content_ids: ids,
            content_type: 'product',
            value: centsToEur(cart.total_price),
            currency: 'EUR',
            num_items: cart.item_count
          }, { eventID: eventId('ic') });
        })
        .catch(function () {});
    });
  }

  // --- ViewCart: /cart page load + cart drawer open (custom event) ---
  // Custom (not standard Meta) event — usable for retargeting audiences,
  // not for AEM optimisation. Throttle prevents rapid drawer toggles
  // from inflating event volume.
  var lastViewCartAt = 0;
  var VIEW_CART_THROTTLE_MS = 30000;

  function fireViewCart() {
    var now = Date.now();
    if (now - lastViewCartAt < VIEW_CART_THROTTLE_MS) return;
    lastViewCartAt = now;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        var ids = cart.items.map(function (item) { return String(item.variant_id); });
        fbqSafe('trackCustom', 'ViewCart', {
          content_ids: ids,
          content_type: 'product',
          value: centsToEur(cart.total_price),
          currency: 'EUR',
          num_items: cart.item_count
        }, { eventID: eventId('vcart') });
      })
      .catch(function () {});
  }

  function trackViewCart() {
    if (window.location.pathname === '/cart') {
      fireViewCart();
    }
    // Mirror the cart_drawer_open observer in glend-analytics.js
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.type === 'attributes' && m.attributeName === 'class' && drawer.classList.contains('active')) {
            fireViewCart();
          }
        });
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // Initialize — only after fbq is loaded (which only happens post-consent).
  // The base pixel loader in theme.liquid dispatches 'glend:meta-pixel-ready'
  // once fbq is ready and PageView has fired. We bind subscribers/handlers then,
  // so no events are wired until the user has consented.
  var initialized = false;
  function init() {
    if (initialized) return;
    initialized = true;
    trackViewContent();
    trackSearch();
    trackAddToCart();
    trackInitiateCheckout();
    trackViewCart();
  }

  function boot() {
    if (typeof window.fbq === 'function' && window._glendMetaPixelLoaded) {
      init();
    } else {
      window.addEventListener('glend:meta-pixel-ready', init, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
